import { Component,ViewChild} from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IonInfiniteScroll,ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
import {SchedulingapprovalPage} from "src/app/schedulingapproval/schedulingapproval.page";
declare var app;
@Component({
  selector: 'app-approvalist-management',
  templateUrl: './approvalist-management.component.html',
  styleUrls: ['./approvalist-management.component.scss']
})
export class ApprovalistManagementComponent extends GridBaseCase  {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  dataArrayList: Array<any> = [];
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  errMsg:any={};//错误消息提示
  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private http: HttpCustomerService,
    public com: CommonService,
    public modalCtrl:ModalController
  ) {
    super();
   }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  doRefresh(event){
    event.target.complete();
  }
  LoadData(PageNumber) {
    let that = this;
    // console.log("20190871");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const id=that.activaRouter.snapshot.paramMap.get("id").split("&")[0];
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();

    body.ConfigName = "CopyWeekScheduleNormal";
    if(id=="month"){
      body.ConfigName = "CopyMonthScheduleNormal";
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.errMsg = data.ResponseMessage;//
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        console.log( data.Status,"#####");
        data.Status.forEach(item => {
          item.SNStartDate=item.SNStartDate.replace(/-/g, "/");
          item.SNEndDate=item.SNEndDate.replace(/-/g, "/");
          if(item.SchedulingMethod == 1 || item.SchedulingMethod == "1" ){
            item.TypeName ="临时排班";
          }
        });
        that.dataArrayList=data.Status;
        console.log(that.dataArrayList,"数据数据数据");
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.length;
        if(that.RecordCount == data.Status.length || that.RecordCount == that.dataArrayList.length){
          that.infiniteScroll.disabled = true;
        }else{
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }
  /**
   * 模态框
   */
  async modalButtonClick(item,index){
    let that = this;
    // debugger;
    const modal = await that.modalCtrl.create({
      component: SchedulingapprovalPage,
      componentProps: {
        "items": item
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data,"返回值");
    if(data.result){
      that.dataArrayList[index]=data.result;
    }
  }
  EventClick(){
    let that = this;
    debugger;
    if(that.errMsg.ErrorCode==1){
      that.msg.Confirm(that.errMsg.ErrorMessage,"取消","确定").then(res=>{
        if(res){
          const id=that.activaRouter.snapshot.paramMap.get("id").split("&")[0];
          const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
          let body = new WebParameterContext();
          body.ConfigName = "BatchScheduleNormal";
          body.OpType = "Add";
          body.ConfigType = "form";
          body.RowsPerPage = app.RowsPerPage;
          body.PageNumber = 1;
          body.Client.PageName = PageName;
          body.Client.ApiType = "Element";
          body.Client.Name = that.element.name;
          body.Client.ClientType = 2;
          body.RequestBody=JSON.stringify(that.dataArrayList);
              that.http.post(app.DEFAULTURL, body).then(data => {
                if (data.ResponseMessage.Success) {
                  that.msg.Alert("提交成功").then(data=>{
                    that.com.goBack();
                  });
                }else{
                  that.msg.Alert(data.ResponseMessage.ErrorMessage);
                }
              }).catch(error => {
                that.apiObj['status'] = false;
                that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
                that.loading = true;
                console.log(error);
              }); 
        }
      });

    }else{
      const id=that.activaRouter.snapshot.paramMap.get("id").split("&")[0];
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.ConfigName = "BatchScheduleNormal";
      body.OpType = "Add";
      body.ConfigType = "form";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = 1;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      body.RequestBody=JSON.stringify(that.dataArrayList);
      that.msg.Confirm("确定提交吗?","取消","确定").then(res=>{
        if(res){
          that.http.post(app.DEFAULTURL, body).then(data => {
            if (data.ResponseMessage.Success) {
              that.msg.Alert("提交成功").then(data=>{
                that.com.goBack();
              });
            }else{
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          }).catch(error => {
            that.apiObj['status'] = false;
            that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
            that.loading = true;
            console.log(error);
          });
        }
      });
    }
 

  }
}
